import { render, staticRenderFns } from "./sendingRestrictions.vue?vue&type=template&id=0d1772a1"
import script from "./sendingRestrictions.vue?vue&type=script&lang=js"
export * from "./sendingRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports